import { TRACKER_URL } from 'constants/config';
import { PERMANENT_COOKIE_NAME } from 'constants/cookies';
import { SESSION_ID_NAME } from 'constants/storage';
import { getPaymentId } from 'selectors/entities/payment/payment';
import { getRecipientId } from 'selectors/entities/recipient/recipient';
import { getEmail } from 'selectors/entities/user/user';
import { getCountryCode } from 'selectors/geolocation/geolocation';
import {
  getCurrentLocale,
  getGatewaySource,
  getPlatform,
} from 'selectors/ui/ui';
import { store as defaultStore } from 'store/configureStore';
import { cookies } from 'utils/cookies/cookies';
import { sessionStorage } from 'utils/storage';

export type Tracker = {
  configure: (store: typeof defaultStore) => void;
  trackEvent: (
    event: string,
    payload: Record<string, unknown>,
  ) => Promise<void | Response | undefined>;
  sendEvent: (
    data: Record<string, unknown>,
  ) => Promise<void | Response | undefined>;
};

let configuredStore: typeof defaultStore | null = null;

const tracker: Tracker = {
  configure: function (store: typeof defaultStore) {
    configuredStore = store;
  },

  trackEvent: (event, payload) => {
    const store = configuredStore || defaultStore;
    const state = store?.get()?.getState();

    const sourceUrl = window.location.href;
    const browserLanguage = getCurrentLocale(state);
    const country = getCountryCode(state);
    const recipient = getRecipientId(state);
    const userAccount = getEmail(state);
    const userAgent = navigator.userAgent;
    const referrer = document.referrer;
    const platform = getPlatform(state);
    const gatewaySource = getGatewaySource(state);
    const paymentid = getPaymentId(state) || null;

    return tracker.sendEvent({
      event,
      peer_tracker_id: cookies.read(PERMANENT_COOKIE_NAME),
      session_id: sessionStorage.getItem(SESSION_ID_NAME),
      source_url: sourceUrl,
      browser_language: browserLanguage,
      country,
      portal_code: recipient,
      user_account: userAccount,
      user_agent: userAgent,
      referrer,
      platform,
      gateway_source: gatewaySource,
      paymentid,
      ...payload,
    });
  },

  sendEvent: data => {
    return fetch(TRACKER_URL, getFetchOptions(data)).catch(() => {
      // do nothing
    });
  },
};

const getFetchOptions = (payload: Record<string, unknown>) => {
  const body = JSON.stringify(payload);
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  const method = 'POST';

  return { body, headers, method };
};

export { tracker };
